export default __webpack_public_path__ + "static/media/mec.e1d8903e.png";